import settings from '@/settings.js'
import BaseLine from '@/components/common/BaseLine'
import OtherLogin from '@/components/login/OtherLogin'
import BaseInput from '@/components/common/BaseInput.vue'
import { checkFromType } from '@/utils/checkLoginFromType'
import { getBusinessType } from '@/constant'
export default {
  components: {
    BaseInput,
    BaseLine,
    OtherLogin,
  },

  data() {
    return {
      preTelList: settings.preTelList,
      form: {
        pretel: '86',
      },
    }
  },
  computed: {
    // 包含活动侧边内容
    hasBanner() {
      return  getBusinessType().isMergeLoginAndRegister ? false : this.fromEvent || this.fromGuest
    },

    // 活动id
    eventId() {
      return this.$route.query.event_id
    },

    // 嘉宾邀请id
    gi_guest() {
      return this.fromGuest && this.$route.query.gi_guest
    },

    // 从哪来：活动url or 嘉宾邀请 or 平台
    fromType() {
      return checkFromType(this.$route)
    },

    // 来自平台
    fromPlatform() {
      return getBusinessType().isMergeLoginAndRegister ? false: !this.hasBanner
    },

    // 来自嘉宾邀请
    fromGuest() {
      return this.fromType === 'guest'
    },

    // 来自活动url
    fromEvent() {
      return this.fromType === 'event'
    },

    // 类型：国内or国外 email/phone
    type() {
      return this.$route.params.type || 'phone'
    },

    // 步骤：账号or详情 account | detail/账号
    step() {
      return this.$route.params.step || 'account'
    },

    // 是否位于首页
    isIndex() {
      return this.step === 'account'
    },
    isDialog() {
      return this.$store.state.isDialog || false
    },
    isMobileDialog() {
      return this.$store.state.isMobileDialog || false
    },
  },

  created() {
    // console.log(window.location.href, 'BASEMIXIN')
  },

  methods: {},
}
